export default __webpack_public_path__ + "assets/a220d39bf813a37c1f4ff88b44a899ed.jpg";